import React,{ useState } from 'react'
import { useRouteMatch, matchPath } from 'react-router-dom'
import LayoutMenu from '../../components/layoutMenu'
import MenuLink from '../../components/menuLink'
// import TrackSlider from '../../components/trackSlider'
import './Breadcrumb.css'

const Spacer = ({ autoHide }) => (
  <div className={autoHide ? 'g-spacer-hor' : ''}>
    &nbsp;&nbsp;&nbsp;
  </div>
)

const Breadcrumb = ({
  artist,
  job,
  page,
  showBio = true,
  // showControllers = true,
  // showVolume = true,
  // backPath = false
}) => {
  const [hoverLink, setHoverLink] = useState(false)
  const { url } = useRouteMatch()

  return (
    <>
      <LayoutMenu>
        <div className="g-header">
          <div>
            <MenuLink
              muteHover
              active
              audioName={artist.name}
            >
              {artist?.name}
            </MenuLink>
          </div>

          <div>
            {showBio && (
              <MenuLink
                muteHover
                to={`${artist?.path}/bio`}
                audioName={artist.name}
              >
                Bio
              </MenuLink>
            )}
          </div>
        </div>
      </LayoutMenu>

      <LayoutMenu bottom>
        <div className="g-breadcrumb-back">
          <MenuLink
            to="/"
            onMouseEnter={() => setHoverLink(true)}
            onMouseOut={() => setHoverLink(false)}
            audioName="Menu"
          >
            {hoverLink ? (
              <img
                alt="Voltar"
                src="/assets/images/back_hover.png"
                className="g-shadow-glow"
              />
            ) : (
              <img alt="Voltar" src="/assets/images/back.gif" />
            )}
          </MenuLink>
        </div>
        <div className="g-breadcrumb">
          <div className="g-breadcrumb-lines">
            <div className="g-breadcrumb-line">
              <div className="g-breadcrumb-albums">
                {page && job.pages.map((p1, i) => {
                  const notLast = i < job.pages.length -1
                  const to = `.${p1.path}`
                  const match = matchPath(url, {
                    path: `${artist.path}${job.path}${p1.path}`,
                  })
                  const active = Boolean(match)

                  return (
                    <React.Fragment key={p1.id}>
                      <MenuLink
                        muteHover
                        to={to}
                        active={active}
                        audioName={artist.name}
                      >
                        {p1.link}
                      </MenuLink>
                      {notLast && <Spacer />} 
                    </React.Fragment>
                  )
                })}
              </div>
              <div className="g-breadcrumb-track-name">
                <MenuLink muteHover active audioName={artist.name}>
                  {page?.title}
                </MenuLink>
              </div>
            </div>
            <div className="g-breadcrumb-line">
              {artist.jobs.map((j1, i) => {
                const notLast = i < artist.jobs.length -1
                const to = `${artist.path}${j1.path}`
                const match = matchPath(url, {
                  path: `${artist.path}${j1.path}`,
                })
                const active = Boolean(match)

                return (
                  <React.Fragment key={i}>
                    <MenuLink
                      muteHover
                      to={to}
                      active={active}
                      audioName={artist.name}
                    >
                      {j1.title}
                    </MenuLink>
                    {notLast && <Spacer autoHide />} 
                  </React.Fragment>
                )
              })}
            </div>
          </div>
        </div>
      </LayoutMenu>
    </>
  )
}

export default Breadcrumb
